import styled from 'styled-components';
import { Layout } from 'antd';
import Container from '../wrapper/Container';
const { Header } = Layout;

const HeaderWrapper = styled(Header)`
  background-color: white;
  border-bottom: 1px solid #acacac40;
  margin-bottom: 1rem;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
`;

const AddressHeaderWrapper = styled.div`
  display: flex;
  text-align: center;
  border-right: 1px solid
    ${(props) => (props.showBorder ? props.theme.borderColor : 'transparent')};
  padding-left: 1rem;
  padding-right: 1rem;
`;

const AddressText = styled.div`
  font-size: ${(props) => props.theme.textSizeNormal};
  color: ${(props) =>
    props.isTitle ? props.theme.primaryColor : props.theme.normalTextColor};
  margin-right: ${(props) => (props.isTitle ? '6px' : 0)};
`;

const HeaderContainer = styled(Container)`
  display: flex;
  justify-content: space-between;
`;

const IconWrapper = styled.div`
  margin-right: 8px;
  :hover {
    color: ${(props) => props.theme.primaryColor};
    cursor: pointer;
  }
`;

export {
  HeaderWrapper,
  AddressHeaderWrapper,
  AddressText,
  HeaderContainer,
  IconWrapper,
};
